import type React from "react";
import { Form, Spin, Tabs } from "antd";
import "./lessonForm.scss";
import { ActivityType } from "../../../types";
import { LessonFormProvider, useLessonForm } from "./components/LessonFormContext";
import LessonFormHeader from "./components/LessonFormHeader";
import LessonMetaFields from "./components/LessonMetaFields";
import ActivityTabPane from "./components/ActivityTabPane";
import ActivityReorderButton from "./components/ActivityReorderButton";
import FormActions from "./components/FormActions";
import EntityHistory from "../../EntityHistory";

export const LessonFormInner: React.FC = () => {
  const { lesson, activeTab, setActiveTab, isLoading, currentLessonId } =
    useLessonForm();

  if (isLoading) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" tip="Cargando leccion..." />
      </div>
    );
  }

  return (
    <div className="lesson-form-container">
      <LessonFormHeader />
      <Form layout="vertical" initialValues={lesson}>
        <LessonMetaFields />

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          className="activity-tabs"
          tabBarExtraContent={{ right: <ActivityReorderButton /> }}
        >
          <Tabs.TabPane tab="Inicio" key={ActivityType.START}>
            <ActivityTabPane type={ActivityType.START} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Desarrollo" key={ActivityType.MIDDLE}>
            <ActivityTabPane type={ActivityType.MIDDLE} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Cierre" key={ActivityType.CLOSING}>
            <ActivityTabPane type={ActivityType.CLOSING} />
          </Tabs.TabPane>
          {currentLessonId && (
            <Tabs.TabPane tab="Historial" key="history">
              <EntityHistory entityType="lessons" entityId={currentLessonId} />
            </Tabs.TabPane>
          )}
        </Tabs>

        <FormActions />
      </Form>
    </div>
  );
};

const LessonForm: React.FC = () => (
  <LessonFormProvider>
    <LessonFormInner />
  </LessonFormProvider>
);

export default LessonForm;
